module.exports = __webpack_public_path__ + "static/img/subNews2.d4c06c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/daoba-match/assets/sportsLogo/subNews2.png
// module id = NQ6M
// module chunks = 9